// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"fc73ff07","872":"7441c8a7","918":"eca368af"}[chunkId] + ".chunk.js";
};